import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

export const DIMENSION_AS_MEASURE_SELECT_QUERY =
  dbTableCampaign.DIMENSION_AS_MEASURE_SELECT_QUERY;
